import { type UseQueryResult, useQuery } from 'react-query';
import { ParticipantLiquidNetWorthService } from '../../services/wealthlane-customer-services';

const useGetParticipantLiquidNetWorth = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const ParticipantLiquidNetWorthList = useQuery(
    ['getParticipantLiquidNetWorthList'],
    async () => {
      return await handleRequest(
        ParticipantLiquidNetWorthService.getApiCustomerApiAppParticipantLiquidNetWorthParticipantLiquidNetWorthsList()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return ParticipantLiquidNetWorthList;
};
export default useGetParticipantLiquidNetWorth;
